/**
 * @deprecated `SideTabs` is deprecated. Use `SideSubNavigation` instead.
 */
export const sideTabPaddingX = '--side-tab-padding-x';

/**
 * @deprecated `SideTabs` is deprecated. Use `SideSubNavigation` instead.
 */
export const sideTabsLayoutPaddingY = '--side-tabs-layout-padding-y';
